/* eslint-disable import/no-cycle */
import { BoxSchemaType } from '../../../redux/schema/slice';
import FORM_FIELDS from '../fields';

const comparisonSchema: BoxSchemaType = {
  type: 'comparisionData',
  hasBody: true,
  instances: { default: 3, max: 3 },
  fields: [
    FORM_FIELDS.PRODUCT_TITLE,
    FORM_FIELDS.PRODUCT_URL,
    FORM_FIELDS.IMAGE_URL,
    FORM_FIELDS.PRODUCT_SUBTITLE,
    FORM_FIELDS.BUY_BUTTON_TEXT,
    FORM_FIELDS.RIBBON_TEXT,
  ],
};

export default comparisonSchema;
